var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "合并订单",
        visible: _vm.visible,
        width: "950px",
        center: "",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _vm.showdetail
        ? _c(
            "div",
            { staticStyle: { "min-height": "50px" } },
            [
              _vm.preMergeList && _vm.preMergeList.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "new-sort-style orderInfo",
                      staticStyle: { "padding-left": "10px" },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { indeterminate: _vm.isIndeterminate },
                              on: { change: _vm.handleCheckAllChange },
                              model: {
                                value: _vm.checkAll,
                                callback: function ($$v) {
                                  _vm.checkAll = $$v
                                },
                                expression: "checkAll",
                              },
                            },
                            [_vm._v("全选")]
                          ),
                          _c("i", { staticClass: "el-icon-info" }),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.preMergeList[0].receiveName || "")
                            ),
                          ]),
                          _c("span", { staticClass: "y-ml-40" }, [
                            _vm._v(
                              _vm._s(_vm.preMergeList[0].receiveMobile || "")
                            ),
                          ]),
                          _c("span", { staticClass: "y-ml-40" }, [
                            _vm._v("共有"),
                          ]),
                          _c(
                            "span",
                            { staticStyle: { "font-weight": "600" } },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.preMergeList.length) + " "
                              ),
                            ]
                          ),
                          _c("span", [
                            _vm._v("笔订单可以手动合并，请选择合并的订单"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          staticClass: "new-sort-style-select y-w-150",
                          staticStyle: { width: "155px" },
                          attrs: {
                            "popper-append-to-body": false,
                            placeholder: "请选择",
                          },
                          on: { change: _vm.handleOrderByTypeChange },
                          model: {
                            value: _vm.orderByType,
                            callback: function ($$v) {
                              _vm.orderByType = $$v
                            },
                            expression: "orderByType",
                          },
                        },
                        [
                          _vm._l(_vm.orderTypeList, function (item, index) {
                            return [
                              _vm.curComponent == "APPLY_ORDER" &&
                              (item.value == "createTimeDesc" ||
                                item.value == "createTimeAsc" ||
                                item.value == "payTimeDesc" ||
                                item.value == "payTimeAsc" ||
                                item.value == "expShipTimeDesc" ||
                                item.value == "expShipTimeAsc")
                                ? _c(
                                    "el-tooltip",
                                    {
                                      key: index,
                                      attrs: {
                                        placement: "left",
                                        effect: "light",
                                        "popper-class":
                                          "select-option-tooltip-style",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "tip-title" },
                                            [_vm._v(_vm._s(item.name))]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "tip-title-sub" },
                                            [_vm._v("规则")]
                                          ),
                                          _c("div", [
                                            _vm._v(_vm._s(item.rule)),
                                          ]),
                                          _c(
                                            "div",
                                            { staticClass: "tip-title-sub" },
                                            [_vm._v("示例")]
                                          ),
                                          _c("div", [
                                            _vm._v(_vm._s(item.demo)),
                                          ]),
                                          _c(
                                            "div",
                                            { staticClass: "tip-title-sub" },
                                            [_vm._v("适用场景")]
                                          ),
                                          _c("div", [
                                            _vm._v(_vm._s(item.scenarios)),
                                          ]),
                                        ]
                                      ),
                                      _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.name,
                                          value: item.value,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.preMergeList && _vm.preMergeList.length > 0
                ? _c(
                    "el-checkbox-group",
                    {
                      staticClass: "mergeStyle",
                      model: {
                        value: _vm.typeList,
                        callback: function ($$v) {
                          _vm.typeList = $$v
                        },
                        expression: "typeList",
                      },
                    },
                    _vm._l(_vm.preMergeList, function (item, index) {
                      return _c("div", { key: index }, [
                        item.mergeOrderDetail &&
                        item.mergeOrderDetail.length > 0
                          ? _c(
                              "div",
                              { staticClass: "moreOrder" },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    staticClass: "checkItem",
                                    attrs: { label: item },
                                  },
                                  [
                                    [
                                      _c("div", { staticClass: "totalOrder" }, [
                                        _vm._v(
                                          "合：" +
                                            _vm._s(item.mergeOrderDetail.length)
                                        ),
                                      ]),
                                    ],
                                  ],
                                  2
                                ),
                                _vm._l(
                                  item.mergeOrderDetail,
                                  function (items, index) {
                                    return _c("div", { key: index }, [
                                      _c(
                                        "div",
                                        { staticClass: "orderDetailtitle" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "orderDetailNum" },
                                            [_vm._v("订单" + _vm._s(index + 1))]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "last3-span" },
                                            [
                                              _vm._v(
                                                "订单号：" +
                                                  _vm._s(items.orderId)
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "detailinfo",
                                              attrs: {
                                                effect: "light",
                                                content:
                                                  items.receiveName ||
                                                  "" +
                                                    " " +
                                                    items.receiveMobile ||
                                                  "" +
                                                    " " +
                                                    items.receiveProvince ||
                                                  "" + items.receiveCity ||
                                                  "" + items.receiveDistrict ||
                                                  "" + items.receiveAddress ||
                                                  "",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "last2-span y-ml-60",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      items.receiveName || ""
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        items.receiveMobile ||
                                                          ""
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        items.receiveProvince ||
                                                          ""
                                                      ) +
                                                      _vm._s(
                                                        items.receiveCity || ""
                                                      ) +
                                                      _vm._s(
                                                        items.receiveDistrict ||
                                                          ""
                                                      ) +
                                                      _vm._s(
                                                        items.receiveAddress ||
                                                          ""
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm.orderByType == "createTimeDesc" ||
                                          _vm.orderByType == "createTimeAsc"
                                            ? _c(
                                                "span",
                                                { staticClass: "last1-span" },
                                                [
                                                  _vm._v(
                                                    _vm._s(items.createTime)
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.orderByType == "payTimeDesc" ||
                                          _vm.orderByType == "payTimeAsc"
                                            ? _c(
                                                "span",
                                                { staticClass: "last1-span" },
                                                [_vm._v(_vm._s(items.payTime))]
                                              )
                                            : _vm._e(),
                                          _vm.orderByType ==
                                            "expShipTimeDesc" ||
                                          _vm.orderByType == "expShipTimeAsc"
                                            ? _c(
                                                "span",
                                                { staticClass: "last1-span" },
                                                [
                                                  _vm._v(
                                                    _vm._s(items.lastShipTime)
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      items.orderProducts
                                        ? _c(
                                            "div",
                                            _vm._l(
                                              items.orderProducts,
                                              function (orderitem, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "orderDetail",
                                                  },
                                                  [
                                                    _c("el-image", {
                                                      staticClass: "orderImg",
                                                      attrs: {
                                                        src: orderitem.thumbImg,
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "orderDetailInfo",
                                                      },
                                                      [
                                                        _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              orderitem.productName
                                                            )
                                                          ),
                                                        ]),
                                                        orderitem.skuAttrs &&
                                                        JSON.parse(
                                                          orderitem.skuAttrs
                                                        ).length > 0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "y-mt-10",
                                                              },
                                                              _vm._l(
                                                                JSON.parse(
                                                                  orderitem.skuAttrs
                                                                ),
                                                                function (
                                                                  specItem,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "span",
                                                                    {
                                                                      key: index,
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          specItem.attr_value
                                                                        ) +
                                                                          _vm._s(
                                                                            index +
                                                                              1 ===
                                                                              JSON.parse(
                                                                                orderitem.skuAttrs
                                                                              )
                                                                                .length
                                                                              ? ""
                                                                              : " / "
                                                                          )
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "y-mt-10",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "* " +
                                                                _vm._s(
                                                                  orderitem.skuCnt
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ])
                                  }
                                ),
                              ],
                              2
                            )
                          : _c(
                              "div",
                              { staticClass: "aloneOrder" },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    staticClass: "checkItem",
                                    attrs: { label: item },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "checkItemInfo" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "订单号：" + _vm._s(item.orderId)
                                          ),
                                        ]),
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "receiveinfo",
                                            attrs: {
                                              effect: "light",
                                              content:
                                                item.receiveName ||
                                                "" + " " + item.receiveMobile ||
                                                "" +
                                                  " " +
                                                  item.receiveProvince ||
                                                "" + item.receiveCity ||
                                                "" + item.receiveDistrict ||
                                                "" + item.receiveAddress ||
                                                "",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "last2-span-2 y-ml-60",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.receiveName || ""
                                                  ) +
                                                    " " +
                                                    _vm._s(
                                                      item.receiveMobile || ""
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      item.receiveProvince || ""
                                                    ) +
                                                    _vm._s(
                                                      item.receiveCity || ""
                                                    ) +
                                                    _vm._s(
                                                      item.receiveDistrict || ""
                                                    ) +
                                                    _vm._s(
                                                      item.receiveAddress || ""
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm.orderByType == "createTimeDesc" ||
                                        _vm.orderByType == "createTimeAsc"
                                          ? _c(
                                              "span",
                                              { staticClass: "last1-span-1" },
                                              [_vm._v(_vm._s(item.createTime))]
                                            )
                                          : _vm._e(),
                                        _vm.orderByType == "payTimeDesc" ||
                                        _vm.orderByType == "payTimeAsc"
                                          ? _c(
                                              "span",
                                              { staticClass: "last1-span-1" },
                                              [_vm._v(_vm._s(item.payTime))]
                                            )
                                          : _vm._e(),
                                        _vm.orderByType == "expShipTimeDesc" ||
                                        _vm.orderByType == "expShipTimeAsc"
                                          ? _c(
                                              "span",
                                              { staticClass: "last1-span-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(item.lastShipTime)
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                item.orderProducts
                                  ? _c(
                                      "div",
                                      _vm._l(
                                        item.orderProducts,
                                        function (items, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "orderDetail",
                                            },
                                            [
                                              _c("el-image", {
                                                staticClass: "orderImg",
                                                attrs: { src: items.thumbImg },
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "orderDetailInfo",
                                                },
                                                [
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(items.productName)
                                                    ),
                                                  ]),
                                                  items.skuAttrs &&
                                                  JSON.parse(items.skuAttrs)
                                                    .length > 0
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "y-mt-10",
                                                        },
                                                        _vm._l(
                                                          JSON.parse(
                                                            items.skuAttrs
                                                          ),
                                                          function (
                                                            specItem,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "span",
                                                              { key: index },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    specItem.attr_value
                                                                  ) +
                                                                    _vm._s(
                                                                      index +
                                                                        1 ===
                                                                        JSON.parse(
                                                                          items.skuAttrs
                                                                        ).length
                                                                        ? ""
                                                                        : " / "
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "span",
                                                    { staticClass: "y-mt-10" },
                                                    [
                                                      _vm._v(
                                                        "* " +
                                                          _vm._s(items.skuCnt)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                      ])
                    }),
                    0
                  )
                : _vm._e(),
            ],
            1
          )
        : _c(
            "div",
            [
              _c("div", { staticClass: "orderInfo" }, [
                _c("i", { staticClass: "el-icon-info" }),
                _vm._v(" 请选择合并后的地址 "),
              ]),
              _c(
                "el-radio-group",
                {
                  staticClass: "mergeStyle",
                  model: {
                    value: _vm.radio,
                    callback: function ($$v) {
                      _vm.radio = $$v
                    },
                    expression: "radio",
                  },
                },
                _vm._l(_vm.typeList, function (i, index) {
                  return _c(
                    "el-radio",
                    {
                      key: index,
                      staticClass: "checkItem",
                      attrs: { label: i },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.preMergeList[index].receiveName || "") +
                          " " +
                          _vm._s(_vm.preMergeList[index].receiveMobile || "") +
                          " " +
                          _vm._s(
                            _vm.preMergeList[index].receiveProvince || ""
                          ) +
                          _vm._s(_vm.preMergeList[index].receiveCity || "") +
                          _vm._s(
                            _vm.preMergeList[index].receiveDistrict || ""
                          ) +
                          _vm._s(_vm.preMergeList[index].receiveAddress || "") +
                          " "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          !_vm.showdetail
            ? _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showdetail = true
                    },
                  },
                },
                [_vm._v("上一步")]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _vm.showdetail
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.toNext } },
                [_vm._v("下一步")]
              )
            : _vm._e(),
          !_vm.showdetail
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.toMerge } },
                [_vm._v("确认合并")]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }